/**
 * Site related types that match the backend DTOs
 */

export interface EmergencyContact {
  name: string;
  jobTitle: string;
  contactNumber: string;
}

export interface Site {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  latitude: number;
  longitude: number;
  geofenceRadius: number;
  companyId?: string;
  description?: string;
  clientId?: string;
  clientName?: string;
  emergencyContacts?: EmergencyContact[];
  distance?: number; // Distance from user's current location in kilometers
}


export enum PhotoRequirement {
  Required = 0,
  Optional = 1,
  None = 2
}

export interface SiteTask {
  id: string;
  siteId: string;
  taskLocation: string;
  qrCode?: string;
  instructions: string;
  frequency: string;
  intervalHours?: number;
  orderNumber: number;
  photoRequirement: PhotoRequirement;
}

export interface CreateSiteTaskRequest {
  taskLocation: string;
  qrCode?: string;
  instructions: string;
  frequency: string;
  intervalHours?: number;
  orderNumber?: number;
  photoRequirement?: PhotoRequirement;
}

export interface UpdateSiteTaskRequest {
  taskLocation?: string;
  qrCode?: string;
  instructions?: string;
  frequency?: string;
  intervalHours?: number;
  orderNumber?: number;
  photoRequirement?: PhotoRequirement;
}

export interface TaskCompletion {
  id: string;
  siteTaskId: string;
  userId: string;
  notes: string;
  imageUrl: string;
  latitude: number;
  longitude: number;
  completedAt: string;
}

export interface CompleteTaskRequest {
  notes: string;
  imageUrl: string;
  latitude: number;
  longitude: number;
  userId?: string;
  isQrCompletion?: boolean;
}

export interface CreateSiteRequest {
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  latitude: number;
  longitude: number;
  geofenceRadius?: number;
  clientId?: string;
  description?: string;
  emergencyContacts?: EmergencyContact[];
}

export interface UpdateSiteRequest {
  name?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  latitude?: number;
  longitude?: number;
  geofenceRadius?: number;
  emergencyContacts?: EmergencyContact[];
}
